export default "__VITE_ASSET__mFuDLFEc__"